import { URLString } from '/src/lib/types';

/**
 * Enums
 */
export enum FileType {}

export enum UploadStatus {
  Ready = 'ready',
  Queued = 'queued',
  Uploading = 'uploading',
  Done = 'done',
}

/**
 * Bulk Import
 */
export type TBulkImportRequest = any[]; // Files

export type TBulkImportResponse = any;

/**
 * S3 Uploads
 */
export type S3UploadRequest = {
  fileName: string;
  fileType: FileType;
};

export type S3UploadResponse = {
  signed_request: any;
  url: URLString;
};
